import React from "react";
import PropTypes from 'prop-types';
import { ProgressSurveyQuestion, ProgressSurveyAnswer } from "../utils/types";
import { fetchAuthenticatedStarfishJSON, apiErrorMessage } from 'utils/request';
import { sortAnswersByStudentNames } from 'utils/surveys';
import ProgressSurveyTableView from "./ProgressSurveyTableView";

export default class ProgressSurveyTableContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      hasFetchedAnswers: false,
      hasFetchedQuestions: false
    };
  }

  componentDidMount() {
    this.getAnswers();
    this.getQuestions();
  }

  componentDidUpdate(prevProps, prevState) {
    if ( prevProps.surveyId !== this.props.surveyId ) {
      this.setState({hasFetchedAnswers: false, hasFetchedQuestions: false});
      this.getAnswers();
      this.getQuestions();
    }

    const wasFullyLoaded = prevState.hasFetchedAnswers && prevState.hasFetchedQuestions;
    if ( this.isFullyLoaded && !wasFullyLoaded ) this.props.onSurveyFullyLoaded();
  }

  getAnswers() {
    const URL = `../survey/getSurveyAnswers.html?surveyResponseId=${this.props.surveyId}`;
    fetchAuthenticatedStarfishJSON(URL, 'answers', { method: 'GET' })
      .then(sortAnswersByStudentNames)
      .then(answers => this.props.onFetch('surveyAnswers', answers))
      .catch(e => this.props.onFailure(apiErrorMessage(e)))
      .then(() => this.setState({hasFetchedAnswers: true}));
  }

  getQuestions() {
    const URL = `../survey/getSurveyQuestions.html?surveyResponseId=${this.props.surveyId}`;
    fetchAuthenticatedStarfishJSON(URL, 'questions', { method: 'GET' })
      .then(questions => this.props.onFetch('surveyQuestions', questions))
      .catch(e => this.props.onFailure(apiErrorMessage(e)))
      .then(() => this.setState({hasFetchedQuestions: true}));
  }

  get isFullyLoaded() {
    return this.state.hasFetchedAnswers && this.state.hasFetchedQuestions;
  }

  render() {
    return (
      <ProgressSurveyTableView
        hasFetched={this.isFullyLoaded}
        surveyAnswers={this.props.surveyAnswers}
        surveyQuestions={this.props.surveyQuestions}
        rebindStudentCards={this.props.rebindStudentCards}
        renderStudent={this.props.renderStudent}
      />
    );
  }
}

ProgressSurveyTableContainer.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onFailure: PropTypes.func.isRequired,
  rebindStudentCards: PropTypes.func.isRequired,
  surveyQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  surveyAnswers: PropTypes.arrayOf(ProgressSurveyAnswer),
  onFetch: PropTypes.func.isRequired,
  renderStudent: PropTypes.func.isRequired,
  onSurveyFullyLoaded: PropTypes.func.isRequired
};
